"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpPlayAssessment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var learnosity_constants_1 = require("../../Constants/learnosity.constants");
var hooks_1 = require("../../../api/hooks");
var react_1 = require("react");
var toolBarSettings = function (isLTI) {
    var elemStart;
    var speechStreamDomControlTools = window.speechstream.domControlTools;
    var speechTools = window.speechstream.speechTools;
    var domControl = speechStreamDomControlTools.getNewDomControl(window.document);
    domControl.addIgnoreListQuerySelector('.skip-link, .sr-item-description, .mq-math-mode, [class^=lrn-accessibility-], .visually-hidden, .test-title-text, .subtitle, .item-count, .timer, .lrn_sort_gripper, .lrn-choicematrix-column-title, footer');
    speechStreamDomControlTools.setStyleList(['!x-marker']);
    if (isLTI) {
        elemStart = document.querySelector('header');
        speechStreamDomControlTools.setStartPoint(elemStart);
    }
    else {
        elemStart = document.getElementById('main');
        speechStreamDomControlTools.setStartPoint(elemStart);
    }
    speechTools.setUseElementLangTags(true);
};
var initializeTextHelp = function (isLTI) {
    var _a, _b, _c, _d;
    if ((_a = window === null || window === void 0 ? void 0 : window.speechstream) === null || _a === void 0 ? void 0 : _a.Loader) {
        window.speechstream.Loader.lateLoad().then(function () {
            toolBarSettings(isLTI);
        });
        var toolBarButtons = ['hover', 'play', 'pause', 'stop', 'screenmask', 'settings'];
        (_c = (_b = window.speechstream) === null || _b === void 0 ? void 0 : _b.Loader) === null || _c === void 0 ? void 0 : _c.setToolBarButtons(toolBarButtons);
    }
    else {
        (_d = window.speechstream) === null || _d === void 0 ? void 0 : _d.toggleBar();
    }
};
/**
 * This component renders the learnosity play attempt functionality.
 * Every event related to the component should be registered here.
 *
 * Reference: https://reference.learnosity.com/items-api
 */
var DpPlayAssessment = function (_a) {
    // ----------------------------- State
    var signedRequest = _a.signedRequest, useTextHelp = _a.useTextHelp, isLTI = _a.isLTI, startHandler = _a.startHandler, submitHandler = _a.submitHandler, saveHandler = _a.saveHandler, exitHandler = _a.exitHandler, confirmHandler = _a.confirmHandler;
    // ----------------------------- Methods
    var initializeLearnosity = (0, react_1.useCallback)(function () {
        var learnosityApi = window[learnosity_constants_1.LEARNOSITY_ITEMS_API];
        if (learnosityApi === null || learnosityApi === void 0 ? void 0 : learnosityApi.reset) {
            learnosityApi.reset();
        }
        var itemsApp = learnosityApi.init(signedRequest, {
            errorListener: function (e) {
                console.log(e);
            },
            readyListener: function () {
                var mathElements = document.getElementsByTagName('math');
                for (var _i = 0, mathElements_1 = mathElements; _i < mathElements_1.length; _i++) {
                    var element = mathElements_1[_i];
                    element.classList.add('d-none');
                }
                var assessApp = itemsApp.assessApp();
                if (useTextHelp)
                    initializeTextHelp(isLTI);
                assessApp.on('all', function (type) {
                    console.log(type);
                });
                assessApp.on('test:start', function () {
                    if (startHandler) {
                        startHandler();
                    }
                });
                assessApp.on('test:save:success', function () {
                    if (saveHandler) {
                        saveHandler();
                    }
                });
                assessApp.on('test:save:error', function () {
                    if (saveHandler) {
                        saveHandler(true);
                    }
                });
                assessApp.on('test:submit:success', function () {
                    if (submitHandler) {
                        submitHandler();
                    }
                });
                assessApp.on('test:submit:error', function () {
                    if (submitHandler) {
                        submitHandler(true);
                    }
                });
                assessApp.on('test:finished:save', function () {
                    if (exitHandler) {
                        exitHandler();
                    }
                });
                assessApp.on('test:finished:submit', function () {
                    if (confirmHandler) {
                        confirmHandler();
                    }
                    else if (exitHandler) {
                        exitHandler();
                    }
                });
                assessApp.on('item:changed', function () {
                    assessApp.save();
                });
            },
        });
    }, [
        startHandler,
        saveHandler,
        submitHandler,
        exitHandler,
        confirmHandler,
        isLTI,
        signedRequest,
        useTextHelp,
    ]);
    (0, hooks_1.useMount)(function () {
        initializeLearnosity();
    });
    // ----------------------------- Render
    return (0, jsx_runtime_1.jsx)("div", { id: "learnosity_assess" });
};
exports.DpPlayAssessment = DpPlayAssessment;
